import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  createComment,
  getAllComment,
} from '../../redux/housekeys_comments/thunks';
import { useSnackbar } from 'notistack';
import { NewCommentEventListener } from '../common/Comments/NewComment/props';
import { CommentsModal } from '../common/Comments';

type HouseKeyCommentsProps = {
  housekey_id?: number | null;
  housekey_code?: string;
  open?: boolean;
  onClose: Function;
};

export const HouseKeyComments = ({
  housekey_id,
  open,
  onClose,
  housekey_code,
}: HouseKeyCommentsProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const { comments, loading } = useAppSelector(
    (state) => state.housekey_comments
  );
  const dispatch = useAppDispatch();
  const [loadedComments, setLoadedComments] = useState<boolean>(true);
  const [selectedHousekey, setSelectedHousekey] = useState<number>(-1);
  useEffect(() => {
    if (housekey_id && !loading && open) {
      setLoadedComments(false);
      dispatch<any>(getAllComment({ housekey_id, page: 1, stackmode: true }))
        .unwrap()
        .then(() => {
          setSelectedHousekey(housekey_id);
          setLoadedComments(true);
        });
    }
  }, [housekey_id]);

  const onNewCommentHandler: NewCommentEventListener = async (
    content: string
  ) => {
    try {
      await dispatch<any>(
        createComment({ housekey_id: selectedHousekey, content })
      ).unwrap();
      enqueueSnackbar('Comentario publicado con éxito!', {
        variant: 'success',
      });
      return true;
    } catch (error) {
      enqueueSnackbar('Hubo un error al registrar el comentario', {
        variant: 'error',
      });
    }
    return false;
  };
  return (
    <>
      {loadedComments && (
        <CommentsModal
          comments={comments}
          title={`Comentarios llave ${housekey_code || ''}`}
          onNewComment={onNewCommentHandler}
          onClose={onClose}
        />
      )}
    </>
  );
};
